export const UNAUTHORIZED_CODE = '403'
export const AUTH_WRONG_PASSWORD = 'auth/wrong-password'
export const AUTH_TOO_MANY_REQUEST = 'auth/too-many-requests'
